import css from "./style.module.css";
import { NavLink } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { fetchfeedback } from "../../api";
const MainPage = () => {
  const [savedMail, setSavedMail] = useState("");
  const [savedTelegram, setSavedTelegram] = useState("");

  useEffect(() => {
    const loadfeedback = async () => {
      const response = await fetchfeedback();
      if (response.success) {
        setSavedMail(response.feedbacks.mail);
        setSavedTelegram(response.feedbacks.telegram);
      } else {
        console.error(response.message);
      }
    };
    loadfeedback();
  }, []);

  return (
    <main className={css.root}>
      <div className="container">
        <div className={css["main-content"]}>
          <div className={css.title}>
            <h1>Сервис для учета заявок по обслуживанию АРМ</h1>
            <h3>
              Оставьте заявку и ждите обратной связи специалиста. <br />
              Либо же осмотрите основные вопросы и разбиритесь с проблемой сами
            </h3>
          </div>
          <div className={css.buttons}>
            <button className={css.btn}>
              <NavLink to="applications">Оставить заявку</NavLink>
            </button>
          </div>
          <div className={css.feedback}>
            <h2>Свяжитесь с нами:</h2>
            <div className={css.feedback__content}>
              <p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 24 24"
                >
                  <g fill="currentColor">
                    <path d="M22 7.535V17a3 3 0 0 1-2.824 2.995L19 20H5a3 3 0 0 1-2.995-2.824L2 17V7.535l9.445 6.297l.116.066a1 1 0 0 0 .878 0l.116-.066z" />
                    <path d="M19 4c1.08 0 2.027.57 2.555 1.427L12 11.797l-9.555-6.37a3 3 0 0 1 2.354-1.42L5 4z" />
                  </g>
                </svg>{" "}
                Эл. почта: {savedMail}
              </p>
              <p>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19c-.14.75-.42 1-.68 1.03c-.58.05-1.02-.38-1.58-.75c-.88-.58-1.38-.94-2.23-1.5c-.99-.65-.35-1.01.22-1.59c.15-.15 2.71-2.48 2.76-2.69a.2.2 0 0 0-.05-.18c-.06-.05-.14-.03-.21-.02c-.09.02-1.49.95-4.22 2.79c-.4.27-.76.41-1.08.4c-.36-.01-1.04-.2-1.55-.37c-.63-.2-1.12-.31-1.08-.66c.02-.18.27-.36.74-.55c2.92-1.27 4.86-2.11 5.83-2.51c2.78-1.16 3.35-1.36 3.73-1.36c.08 0 .27.02.39.12c.1.08.13.19.14.27c-.01.06.01.24 0 .38"
                  />
                </svg>{" "}
                Номер телефона: {savedTelegram}
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default MainPage;
